import conf from '../../conf'

export const url = conf.backend;
export const auth_url = conf.auth_url;
